// Frontend/src/lib/useSseStatus.ts
//
// Lets a React Query hook decide, on every render, whether the live SSE feed
// is doing its job or whether REST polling should step in as the fallback --
// see api/notifications.ts and api/announcements.ts, both of which gate
// their `refetchInterval` on this.

import { useSyncExternalStore } from "react";
import { notificationStream } from "./notificationStream";
import type { SseStatus } from "./sseReconnectPolicy";

export function useSseStatus(): SseStatus {
  return useSyncExternalStore(
    (onStoreChange) => notificationStream.subscribeStatus(() => onStoreChange()),
    () => notificationStream.status
  );
}

/** The one condition every polling fallback cares about: is SSE not working right now? */
export function useSsePollingFallbackActive(): boolean {
  return useSseStatus() === "degraded";
}
